import { render, staticRenderFns } from "./search-box-placeholder.vue?vue&type=template&id=43cbe5f0&"
import script from "./search-box-placeholder.vue?vue&type=script&lang=ts&"
export * from "./search-box-placeholder.vue?vue&type=script&lang=ts&"
import style0 from "./search-box-placeholder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports